/* NgRx */
import { createAction, props } from '@ngrx/store';
import { Filter } from "../../../../models/filter";
import { UsersList } from "../../../../models/users-list";
import {ResendInviteModel} from '../models/resend-invite.model';


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[manage users] clear state';
export const ClearState = createAction(CLEAR_STATE);

/*********** FETCH CLINIC FILTER **************/
const FETCH_CLINIC_FILTER_REQUEST = '[manage users] fetch clinic filter requested';
export const FetchClinicFilterRequest = createAction(FETCH_CLINIC_FILTER_REQUEST, props<{
  payload?: {
    shouldInclude?: number[],
    pageNumber?: number,
    limit?: number,
    searchText?: string
  }
}>());

const FETCH_CLINIC_FILTER_SUCCESS = '[manage users] fetch clinic filter successful';
export const FetchClinicFilterSuccess = createAction(FETCH_CLINIC_FILTER_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_CLINIC_FILTER_FAILURE = '[manage users] fetch clinic filter failure';
export const FetchClinicFilterFailure = createAction(FETCH_CLINIC_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH STATUS FILTER **************/
const FETCH_STATUS_FILTER_REQUEST = '[manage users] fetch status filter requested';
export const FetchStatusFilterRequest = createAction(FETCH_STATUS_FILTER_REQUEST);

const FETCH_STATUS_FILTER_SUCCESS = '[manage users] fetch status filter successful';
export const FetchStatusFilterSuccess = createAction(FETCH_STATUS_FILTER_SUCCESS, props<{
  statusFilter: Filter,
  message: string
}>());

const FETCH_STATUS_FILTER_FAILURE = '[manage users] fetch status filter failure';
export const FetchStatusFilterFailure = createAction(FETCH_STATUS_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH GROUP FILTER **************/
const FETCH_GROUP_FILTER_REQUEST = '[manage users] fetch group filter requested';
export const FetchGroupFilterRequest = createAction(FETCH_GROUP_FILTER_REQUEST, props<{
  payload?: {
    shouldInclude?: number[],
    clientId?: number,
    pageNumber?: number,
    limit?: number,
    search?: string,
    status?: number[],
    sortColumn?: string,
    sortOrder?: number
  }
}>());

const FETCH_GROUP_FILTER_SUCCESS = '[manage users] fetch group filter successful';
export const FetchGroupFilterSuccess = createAction(FETCH_GROUP_FILTER_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_GROUP_FILTER_FAILURE = '[manage users] fetch group filter failure';
export const FetchGroupFilterFailure = createAction(FETCH_GROUP_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH USERS LIST ***********/
const FETCH_USERS_LIST_REQUEST = '[manage users] fetch users list request';
export const FetchUsersListRequest = createAction(FETCH_USERS_LIST_REQUEST, props<any>());

const FETCH_USERS_LIST_SUCCESS = '[manage users] fetch users list success';
export const FetchUsersListSuccess = createAction(FETCH_USERS_LIST_SUCCESS, props<{
  data: UsersList,
  message: string
}>());

const FETCH_USERS_LIST_FAILURE = '[manage users] fetch users list failure';
export const FetchUsersListFailure = createAction(FETCH_USERS_LIST_FAILURE);

/******** FETCH ROLE LIST ***********/
const FETCH_ROLE_LIST_REQUEST = '[manage users] fetch role list request'
export const FetchRolesListRequest = createAction(FETCH_ROLE_LIST_REQUEST)

const FETCH_ROLE_LIST_SUCCESS = '[manage users] fetch role list success'
export const FetchRolesListSuccess = createAction(FETCH_ROLE_LIST_SUCCESS, props<{
  roleList: Filter
}>())

const FETCH_ROLE_LIST_FAILURE = '[manage users] fetch role list failure'
export const FetchRolesListFailure = createAction(FETCH_ROLE_LIST_FAILURE, props<{
  error: any
}>())

/******** UPDATE USER STATUS ***********/
const UPDATE_USER_STATUS_REQUEST = '[manage users] update user status request'
export const UpdateUserStatusRequest = createAction(UPDATE_USER_STATUS_REQUEST, props<{ payload: {
    forUserId: number,
    status: number
  }}>())

const UPDATE_USER_STATUS_SUCCESS = '[manage users] update user status success'
export const UpdateUserStatusSuccess = createAction(UPDATE_USER_STATUS_SUCCESS, props<any>())

const UPDATE_USER_STATUS_FAILURE = '[manage users] update user status failure'
export const UpdateUserStatusFailure = createAction(UPDATE_USER_STATUS_FAILURE, props<{
  error: any
}>())

/******** EDIT PROFILE BY USERID ***********/
const EDIT_PROFILE_BY_USER_ID_REQUEST = "[manage users] edit profile by user id requested";
export const EditProfileByUserIdRequest = createAction(EDIT_PROFILE_BY_USER_ID_REQUEST, props<any>());

const EDIT_PROFILE_BY_USER_ID_SUCCESS = "[manage users] edit profile by user id successful";
export const EditProfileByUserIdSuccess = createAction(EDIT_PROFILE_BY_USER_ID_SUCCESS, props<any>());

const EDIT_PROFILE_BY_USER_ID_FAILURE = "[manage users] edit profile by user id failure";
export const EditProfileByUserIdFailure = createAction(EDIT_PROFILE_BY_USER_ID_FAILURE);

/*********** ASSIGN USER TO NEW GROUP **************/

const ASSIGN_USER_TO_NEW_GROUP_REQUEST = "[manage users] assign user to new group request"
export const AssignUserToNewGroupRequest = createAction(ASSIGN_USER_TO_NEW_GROUP_REQUEST, props<{
  payload: {
    role: number,
    groupId: number,
    clientId?: number,
    participant: { userId: number }
  }
}>());

const ASSIGN_USER_TO_NEW_GROUP_SUCCESS = "[manage users] assign user to new group success"
export const AssignUserToNewGroupSuccess = createAction(ASSIGN_USER_TO_NEW_GROUP_SUCCESS)

const ASSIGN_USER_TO_NEW_GROUP_FAILURE = "[manage users] assign user to new group failure"
export const AssignUserToNewGroupFailure = createAction(ASSIGN_USER_TO_NEW_GROUP_FAILURE)


/*********** RESEND INVITE **************/
const RESEND_INVITE_REQUEST = "[manage users] resend invite request";
export const ResendInviteRequest = createAction(RESEND_INVITE_REQUEST, props<{
  payload: ResendInviteModel['request'],
}>());

const RESEND_INVITE_SUCCESS = "[manage users] resend invite success";
export const ResendInviteSuccess = createAction(RESEND_INVITE_SUCCESS);

const RESEND_INVITE_FAILURE = "[manage users] resend invite failure";
export const ResendInviteFailure = createAction(RESEND_INVITE_FAILURE);
